import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';
import { SEARCH_STATUS } from '../../utils/constants';
import { SEARCH_TABS } from '../../views/SearchTab/constants';
import Actions from './Actions';
import Views from './Views';
import { PROSPECTING_TABS } from './constants';
const SearchQueryMetadataModel = types.model({
    indicatorNotFound: types.boolean,
    indicatorSelector: types.maybeNull(types.string),
    parserType: types.string,
    isUnifiedParser: types.boolean,
    isUnifiedParserEnabled: types.boolean,
    parserCategory: types.string,
    contactsOnPage: types.number,
    contactsParsed: types.number,
    platform: types.string,
});
const SearchQueryModel = types.model('SearchData', {
    contacts: types.array(types.frozen()),
    source_platform: types.string,
    url: types.string,
    product: types.string,
    webPluginVersion: types.string,
    platformView: types.string,
    metadata: SearchQueryMetadataModel,
});
const ModelProps = {
    employeeFreeText: types.optional(types.string, ''),
    requestId: types.optional(types.string, ''),
    sessionId: types.optional(types.string, uuid()),
    searchStatus: types.optional(types.enumeration('SEARCH_STATUS', Object.values(SEARCH_STATUS)), SEARCH_STATUS.IDLE),
    firstSearch: types.optional(types.boolean, true),
    showEmployeesCounterBadge: types.optional(types.boolean, false),
    prospectingActiveTab: types.optional(types.string, PROSPECTING_TABS.company),
    searchActiveTab: types.optional(types.string, SEARCH_TABS.contacts),
    uniqueSearchId: types.optional(types.string, ''),
    creditSplitClickedButtonType: types.maybeNull(types.optional(types.string, 'show')),
    searchQuery: types.optional(types.union(types.null, SearchQueryModel), null), // Union type to allow null or SearchDataModel
    shouldResearchEmployees: types.optional(types.boolean, false),
};
const Search = types.model(ModelProps).actions(Actions).views(Views);
export default Search;
